var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutSideBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2583 34.2583L35.7315 35.7315C31.67 39.7929 26.335 41.8236 21.0001 41.8236C15.6651 41.8236 10.3301 39.7929 6.26859 35.7315C-1.85418 27.6085 -1.85418 14.3916 6.26859 6.26859C14.3916 -1.85418 27.6085 -1.85418 35.7315 6.26859L34.2583 7.74182C26.9478 0.431336 15.0523 0.431336 7.74182 7.74182C0.431211 15.0524 0.431211 26.9477 7.74182 34.2583C15.0524 41.5689 26.9475 41.5689 34.2583 34.2583ZM33.195 29.0283L41.2232 21.0001L33.195 12.9718L31.7218 14.445L37.2353 19.9584H23.0834V22.0417H37.2353L31.7218 27.5551L33.195 29.0283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutSideBar);
export default __webpack_public_path__ + "static/media/logoutSideBar.7086e81652f82a71366696dc826ad06a.svg";
export { ForwardRef as ReactComponent };